var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"makeorder-page-table-quantity-width"},[_c('div',{staticClass:"makeorder-page-table-mobile-header"},[_vm._v("Qtd Emb.")]),_vm._v(" "+_vm._s((_vm.product.flag_generico == 1 || _vm.product.pro_principal) ? _vm.product.quantidadeDigitacao : _vm.product.embalagem.split(" ")[1])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }